

















































































import {Component, Prop, Watch} from 'vue-property-decorator';
import PigeonLogo from '@/components/PigeonLogo.vue';
import {Invite} from '@/domain/model/invite';
import AvatarWithStatus from '@/components/AvatarWithStatus.vue';
import {mixins} from 'vue-class-component';
import Notifications from '@/components/mixins/Notifications';
import TextFieldEmail from '@/components/profile/privacy-security/TextFieldEmail.vue';
import TagManager from '@/mixins/TagManager';

@Component({
  name: 'how-to-use',
  components: {TextFieldEmail, AvatarWithStatus, PigeonLogo}
})
export default class HowToUse extends mixins(Notifications, TagManager) {

  @Prop() value!: boolean;
  role: any;
  loading: boolean = false;
  doubleEmail: any = {}
  existsEmail: string[] = []
  roles: any[] = [
    {name: 'Associate', value: 1},
    {name: 'Admin', value: 3}
  ];
  invites: Invite[] = [
    new Invite(0, '', '', 'signUp'),
  ];

   mounted() {
    document.body.setAttribute('style', 'width: auto; min-width: 0;');
  }

  beforeDestroy() {
    document.body.removeAttribute('style');
  }

  get completedText() {
    return 'Step 2 of 2'
  }

  get circularStyle() {
      return {
        '--progress': 2 * 50
      }
  }

  get show() {
    return this.value;
  }

  set show(value: boolean) {
    this.$emit('input', value);
  }

  moveBack() {
    this.$router.push({name: 'invite-members'});
  }

  goToPigeon() {
    this.loading = true;
    window.localStorage.setItem('isHowToUse', '1');
    this.$router.push({
      path: 'directory',
      name: 'directory'
    });
  }

  onCloseVideoDialog() {
    this.$emit('close-dialog');
    this.value = false;
  }
}
